import classNames from "classnames";
import React from "react";
import "../../App.css";
import { IEvidencePartWrapper } from "@interfaces/Interfaces";
import "./CommonComponents.css";

const EvidencePartWrapper: React.FC<IEvidencePartWrapper> = (props) => {
  return (
    <div
      className={classNames(
        `${props.isErrorBannerVisible && props.isPartIncomplete ? "mandatoryFieldIncomplete !rounded-md" : ""}`,
        {
          "mb-4": props.wrapperControlsBottomMargin,
        }
      )}
      ref={(ref) => {
        if (props.isMandatory) {
          props.handleElementReference(ref!);
        }
      }}
    >
      {props.children}
    </div>
  );
};

export default EvidencePartWrapper;
